import { render } from "./brand-directory.vue?vue&type=template&id=7cd70502"
import script from "./brand-directory.vue?vue&type=script&lang=js"
export * from "./brand-directory.vue?vue&type=script&lang=js"

import "./brand-directory.vue?vue&type=style&index=0&id=7cd70502&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__